<template>
  <div>
    <v-flex xs12>
      <h2 class="text-center mb-5">Valg av strømleverandør</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput
        v-model="stepValues.bool"
        @update-fields="updateFields"
      ></BooleanInput>
    </v-flex>
    <v-flex xs12 v-if="!stepValues.bool.isPowerOrderNeeded.value" class="mt-3">
      <div v-if="!this.stepValues.powerSub">
        <v-flex xs12 sm8 offset-sm2 class="mb-5">
          <slick
            ref="slick"
            :options="slickOptions"
            @afterChange="updateCurrentSlide"
            v-if="slickReady"
          >
            <template v-for="(item, index) in powerSubs">
              <div class="text-center" :key="index + '1'">
                <img :src="item.img" class="mb-3 logo-img" />
                <h4>{{ item.title }}</h4>
                <p>{{ item.description }}</p>
              </div>
            </template>
          </slick>
          <div v-else>
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-flex>
        <v-flex xs12 sm8 offset-sm2 text-center class="mt-3">&nbsp;</v-flex>
        <v-flex xs12 sm8 offset-sm2 class="mt-5 text-center">
          <div style="margin-top: 80px">
            Jeg ønsker at
            {{ protocol.version.protocol_definition.department.company.name }}
            bestiller strøm på mine vegne
          </div>
          <v-btn
            block
            color="primary"
            dark
            class="mt-2"
            @click="setPowerSupplier"
            >Ja, takk</v-btn
          >
          <v-btn block color="secondary" class="mt-3" flat @click="stepValues.bool.isPowerOrderNeeded.value = 1"
            >Nei, Strøm er inkludert / <br />strøm faktureres av eier</v-btn
          >

          <div class="mt-3">
            Avtalen er uten bindingstid, og leietaker kan bytte strømavtale
            gjennom hele leieforholdet
          </div>
        </v-flex>
      </div>
      <div v-else>
          <v-flex xs12 sm8 offset-sm2 class="mb-5 text-center">
              Strøm vil bli bestilt av {{ protocol.version.protocol_definition.department.company.name }}. Valgt strømleverandør er <strong>{{stepValues.powerSub.company}}</strong>
          </v-flex>
          <v-flex xs12 sm8 offset-sm2 class="mb-5 text-center">
              <v-btn
            block
            color="warning"
            dark
            class="mt-2"
            @click="reset"
            >Angre</v-btn
          >
          </v-flex>
      </div>
    </v-flex>
    <StepButtons @next-page="next" @previous-page="previous" class="mt-5" :step="this" />
  </div>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import step from "../../mixins/step";
import Participant from "../../models/participant";
import PersonEditor from "../../components/form/PersonEditor";
export default {
  mixins: [step],
  data() {
    return {
      dialog: false,
      editDialog: false,
      tenants: [],
      slickOptions: {
        slidesToShow: 1,
        dots: true,
      },
      currentSlide: 0,
      powerSubs: [],
      slickReady: false,
      newParticipant: new Participant(),
    };
  },
  components: { Slick },
  activated: function () {
    this.getPowerProducts();
  },
  methods: {
    getPowerProducts() {
      if (!this.selectedPower) {
        this.slickReady = false;
        this.axios
          .get(
            process.env.VUE_APP_PROTOCOL_API +
              "power_products/" +
              this.protocol.hash
          )
          .then((response) => {
            if (!response.data) {
              this.errored = true;
              this.errorText = "Feil: Kunne ikke hente strømabonnementer";
            } else {
              this.powerSubs = response.data;
              this.slickReady = true;
            }
          });
      } else {
        this.slickReady = true;
      }
    },
    updateCurrentSlide() {
      this.currentSlide = this.$refs.slick.currentSlide();
    },
    setPowerSupplier() {
      this.stepValues.powerSub = this.powerSubs[this.currentSlide];
    },
    reset() {
        this.stepValues.powerSub = null
    }
  },
};
</script>

<style>
.slick-slider {
  border: 1px solid #c9c9c9;
  padding: 20px 10px 0px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(229, 229, 229, 1) 100%
  );
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}
.slick-slide img,
.logo-img {
  display: inline;
  width: auto;
  height: 60px;
}
.slick-prev:before,
.slick-next:before {
  color: grey;
}
.slick-dots {
  bottom: -40px;
}
.slick-dots li button:before {
  font-size: 20px;
}
</style>
